var React = require('react');

function IcArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m5.414 11.5 4.793-4.793-1.414-1.414-6.5 6.5-.707.707.707.707 6.5 6.5 1.414-1.414L5.414 13.5H21.5v-2H5.414Z","fill":"currentColor"}));
}

IcArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcArrowLeft;

IcArrowLeft.default = IcArrowLeft;
